import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CatTableHeader } from '@blocks-react/components/TableHeader';
import { CatTableHeaderCell } from '@blocks-react/components/TableHeaderCell';

const ShareListTableHeader = ({ hideBottomBorder }) => {
  const [t] = useTranslation();

  return (
    <CatTableHeader isFrozen>
      <CatTableHeaderCell
        colspan="2"
        border={hideBottomBorder && 'bottom-none'}
      >
        <div className="cat-u-theme-typography-label">
          {t('ACCOUNTS_TO_SHARE')}
        </div>
      </CatTableHeaderCell>
    </CatTableHeader>
  );
};

ShareListTableHeader.propTypes = {
  hideBottomBorder: PropTypes.bool
};

export default ShareListTableHeader;
